"use client";

import { Button, Heading } from "@pamperedchef/design-system";

export default function NotFound(): JSX.Element {
	return (
		<div className="text-center p-md">
			<Heading textContent="404 | Page not found" className="mb-lg" />
			<Button
				kind="primary"
				size="lg"
				onPress={() => {
					window.location.href = "/";
				}}
			>
				Go back home
			</Button>
		</div>
	);
}
